import { Movement } from './../../../shared/models/movement';
import { FileItem } from 'src/app/shared/models/fileItems';
import { CacaoService } from 'src/app/shared/services/cacao.service';
import { MovementsService } from 'src/app/shared/services/movements.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-movements-table',
  templateUrl: './movements-table.component.html',
  styleUrls: ['./movements-table.component.scss']
})
export class MovementsTableComponent implements OnInit {
  private _movements: Movement[];
  private _card: any;
  public filters: {
    dateStart: Date,
    dateEnd: Date
  }
  @Input('movements') set movements(data) {
    this._movements = data;
  }
  @Input('card') set card(data) {
    this._card = data;
    if(this._card) {
      //this.getMovements();
    }
  }

  constructor(
    private movements_service: MovementsService,
    private cacao_service: CacaoService
  ) {
    this.filters = {
      dateStart: new Date(),
      dateEnd: new Date()
    }
  }

  get movements(): Movement[] { return this._movements }
  get card(): any { return this._movements }

  ngOnInit() {
   this.getMovements();
  }
  getMovements(e?) {
    console.log('Obtener Movimientos');
    this.filters.dateStart.setHours(0,0,0).toLocaleString();
    this.filters.dateEnd.setHours(23,59,59).toLocaleString();
    console.log(this.filters);
    this.movements_service.getMovements(this.filters.dateStart,this.filters.dateEnd,this._card.cardNumber).subscribe(
    //this.cacao_service.ConsultarMovimientos(this._card.cardNumber,'2021-12-01', '2021-12-15', null).subscribe(
      (res: any) => {
        console.log(res);
        if(res.data) {
          this.movements = res.data;//.Movimientos;
          console.log(this.movements);
        }
      },
      error => {
        console.log(error);
    });
  }

  onRowPrepared(e) {
    if (e.rowType == "data" && (`${e.data?.urls || ''}`.trim() == "")) {
      e.rowElement.querySelector(".dx-command-expand").firstChild.classList.remove("dx-datagrid-group-closed");
    }  
  }

}
